// const baseUrl =
//     process.env.NEXT_PUBLIC_NODE_ENV === "development"
//         ? process.env.NEXT_PUBLIC_BASE_LOCAL
//         : process.env.NEXT_PUBLIC_BASE;
const baseUrl = process.env.NEXT_PUBLIC_BASE;
export default baseUrl;
